import dayjs from 'dayjs';
import { useCallback, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import API from '../../api';
import { ContentContext, SnackbarContext } from '../../contexts';
import Handler from '../../Handler';

export const useReduction = () => {
  const { slug } = useParams();
  const { updateSnackbar } = useContext(SnackbarContext);
  const { monitoringInfo } = useContext(ContentContext);
  const history = useHistory();
  const { t } = useTranslation();

  const [reduction, setReduction] = useState(null);
  const [reductionProjectList, setReductionProjectList] = useState([]);

  const getReduction = () => {
    if (slug) {
      API.ReductionCert.GetWriting(slug).then((res) => {
        setReduction(res.data);
      });
    }
  };

  const getReductionProjectList = () => {
    API.ReductionCert.GetProject().then((res) => {
      const result = res.data;
      setReductionProjectList(result);
    });
  };

  const genPayload = useCallback(
    (data) => {
      console.log('data', data);
      return {
        startDate: dayjs(data.startDate).format('YYYY.MM.DD'),
        endDate: dayjs(data.endDate).format('YYYY.MM.DD'),
        realReductionBase: data.realReductionBase,
        realReductionBusiness: data.realReductionBusiness,
        realReductionLeak: data.realReductionLeak,
        realReduction: data.realReduction,
        realMonitorDesc: data.realMonitorDesc,
        beforeImages: data.beforeImages?.length > 0 ? data.beforeImages : [],
        afterImages: data.afterImages?.length > 0 ? data.afterImages : [],
        evidenceMapper: Handler.reduceDuplication(data.evidence || [])?.map((item) => ({
          seq: item.seq,
          file: item.data,
          reason: item.reason,
        })),
        additionalEvidence: data.additionalEvidence?.length > 0 ? data.additionalEvidence : [],
      };
    },
    [monitoringInfo, reduction],
  );

  const postReduction = async (projectSeq) => {
    await API.ReductionCert.PostProject(projectSeq)
      .then((res) => {
        const result = res.data;
        console.log('PostNew result', result);
        history.replace(`/reduction/writing/${result.seq}`);
        updateSnackbar({
          type: 'success',
          open: true,
          message: t('SAVED'),
        });
      })
      .catch((err) => {
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data?.message || '저장 중 오류가 발생했습니다.',
        });
        return false;
      });
  };

  const putReduction = async (data) => {
    const payload = genPayload(data);
    try {
      await API.ReductionCert.PutWriting(slug, payload);
      updateSnackbar({
        type: 'success',
        open: true,
        message: t('SAVED'),
      });
      return true;
    } catch (err) {
      updateSnackbar({
        type: 'error',
        open: true,
        message: err.data?.message || '저장 중 오류가 발생했습니다.',
      });
      return false;
    }
  };

  return {
    reduction,
    getReduction,
    postReduction,
    putReduction,
    getReductionProjectList,
    reductionProjectList,
  };
};
